<template>
  <div class="card text-left mb-2">
    <div class="card-header">
      <div class="row">
        <div class="col-auto pr-0">
          <span
            v-if="
              $store.getters.user.Starred_Subjects.some(
                s => s.Subject_Id == subject.Subject_Id
              )
            "
            class="material-icons pointer"
            v-on:click="removeStarSubject"
            v-bind:id="'starredSubject' + subject.Subject_Id"
            @mouseover="$showTooltip('#starredSubject' + subject.Subject_Id)"
            @mouseleave="$hideTooltip('#starredSubject' + subject.Subject_Id)"
            data-placement="top"
            title="Remove subject from starred subjects (appears on dashboard)."
          >
            star
          </span>
          <span
            v-else
            class="material-icons pointer"
            v-on:click="createStarSubject"
            v-bind:id="'starSubject' + subject.Subject_Id"
            @mouseover="$showTooltip('#starSubject' + subject.Subject_Id)"
            @mouseleave="$hideTooltip('#starSubject' + subject.Subject_Id)"
            data-placement="top"
            title="Add subject to starred subjects (appears on dashboard)."
          >
            star_border
          </span>
        </div>
        <div class="col-auto">
          <h5
            v-if="!$route.path.includes('dashboard') && canEdit"
            class="text-primary pointer mb-0 d-inline"
            v-on:click="$emit('edit-subject')"
          >
            {{ subject.Title }}
          </h5>
          <h5 v-else class="mb-0">{{ subject.Title }}</h5>
        </div>
        <div class="col-auto">
          <h6
            v-if="!$route.path.includes('dashboard') && canEdit"
            v-on:click="$emit('manage-students')"
            class="btn-link pt-1 pointer d-inline ml-4"
          >
            {{ students.length }} Student(s)
          </h6>
          <h6 v-else class="text-secondary pt-1 d-inline ml-4">
            {{ students.length }} Student(s)
          </h6>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div
        class="row mb-1"
        v-for="unit in subject.Units.slice().sort($orderByTitle)"
        :key="unit.Unit_Id"
      >
        <div class="col">
          <div class="row">
            <div class="col-auto px-0">
              <i
                class="material-icons pointer pt-1"
                v-bind:id="unit.Unit_Id + 'unitToggleIcon'"
                data-toggle="collapse"
                v-bind:href="'#unitStudents' + unit.Unit_Id"
                role="button"
                aria-expanded="false"
                v-on:click="
                  $updateToggleIcon('#' + unit.Unit_Id + 'unitToggleIcon')
                "
                >add</i
              >
            </div>
            <div class="col-auto pl-1 pr-2 pt-1">
              <p
                v-if="!$route.path.includes('dashboard') && canEdit"
                class="text-primary pointer mb-0 d-inline"
                v-on:click="$emit('manage-unit', unit, subject)"
              >
                <b>
                  {{ unit.Title }}
                </b>
              </p>
              <p v-else>{{ unit.Title }}</p>
            </div>
            <div class="col-auto pl-0">
              <button
                v-if="canEdit"
                class="btn btn-sm btn-primary py-0"
                v-on:click="$emit('add-unit-score', unit, subject)"
              >
                Add Data
              </button>
            </div>
          </div>
          <div class="row">
            <div
              class="col container collapse ml-4"
              v-bind:id="'unitStudents' + unit.Unit_Id"
            >
              <div class="row">
                <div
                  class="mb-1 col"
                  style="background-color:gray; height:1px; width:100%"
                />
              </div>
              <div
                class="row"
                v-for="student in students.filter(s =>
                  s.Units.some(u => u.Unit_Id == unit.Unit_Id)
                )"
                :key="'student' + student.Student_Id + 'unit' + unit.Unit_Id"
              >
                <div class="col">
                  <p class="mb-1">{{ student.Name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!$route.path.includes('dashboard') && canEdit"
        class="row mt-2"
      >
        <div class="col">
          <button
            class="btn btn-sm btn-outline-primary"
            v-on:click="$emit('new-unit', subject)"
          >
            New Unit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Subject: Object,
    Students: Array
  },
  watch: {
    Students: function() {
      this.students = this.getSubjectStudents();
    }
  },
  data() {
    return {
      subject: this.Subject,
      students: this.getSubjectStudents(),
      canEdit: this.canEditSubject()
    };
  },
  methods: {
    getSubjectStudents() {
      return this.Students.filter(s =>
        s.Subjects.some(su => su.Subject_Id == this.Subject.Subject_Id)
      );
    },
    canEditSubject() {
      return this.$canManageSubject(
        this.$store.getters.user.Permissions,
        this.Subject.Subject_Id,
        this.Subject.Organization_Id
      );
    },
    async removeStarSubject() {
      this.$store.commit("updateLoading", true);
      await this.$removeStarSubject(this.subject.Subject_Id);
      this.$emit("starred-subject-removed", this.subject.Subject_Id);
      this.$store.commit("updateLoading", false);
    },
    async createStarSubject() {
      this.$store.commit("updateLoading", true);
      await this.$createStarSubject(this.subject.Subject_Id);
      this.$store.commit("updateLoading", false);
    }
  }
};
</script>
